// extracted by mini-css-extract-plugin
export default {"hierarchyBreadcrumbs":"breadcrumbs_hierarchyBreadcrumbs__UKoYE","item":"breadcrumbs_item__OD6s1"};